(function () {
  if (window.ecoTooltipInitialised) return;
  window.ecoTooltipInitialised = true;

  function initEcoTooltip() {
    let tooltip = document.querySelector('.eco-floating-tooltip');

    if (!tooltip) {
      tooltip = document.createElement('div');
      tooltip.className = 'eco-floating-tooltip';
      tooltip.setAttribute('role', 'tooltip');
      document.body.appendChild(tooltip);
    }

    function getLeafFromEvent(event) {
      if (!(event.target instanceof Element)) {
        return null;
      }

      return event.target.closest('.eco-product-leaf');
    }

    function showEcoTooltip(leaf) {
      const text =
        leaf.dataset.ecoTooltip ||
        leaf.dataset.ecoLabel;

      if (!text) return;

      tooltip.textContent = text;
      tooltip.classList.add('is-visible');

      const rect = leaf.getBoundingClientRect();

      tooltip.style.left = `${rect.left + rect.width / 2}px`;
      tooltip.style.top = `${rect.top - 8}px`;
    }

    function hideEcoTooltip() {
      tooltip.classList.remove('is-visible');
    }

    document.addEventListener('mouseover', function (event) {
      const leaf = getLeafFromEvent(event);

      if (leaf) {
        showEcoTooltip(leaf);
      }
    });

    document.addEventListener('mouseout', function (event) {
      const leaf = getLeafFromEvent(event);

      if (leaf) {
        hideEcoTooltip();
      }
    });

    document.addEventListener('focusin', function (event) {
      const leaf = getLeafFromEvent(event);

      if (leaf) {
        showEcoTooltip(leaf);
      }
    });

    document.addEventListener('focusout', function (event) {
      const leaf = getLeafFromEvent(event);

      if (leaf) {
        hideEcoTooltip();
      }
    });

    window.addEventListener('scroll', hideEcoTooltip, true);
    window.addEventListener('resize', hideEcoTooltip);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initEcoTooltip);
  } else {
    initEcoTooltip();
  }
})();